/**
 * This is the entry point for the Perk Client.
*/
import 'babel-polyfill';

import createHistory from 'history/createBrowserHistory';
import { setupFeatureFramework } from '@surfline/web-common/dist/features/splitio';
import { identitySelector } from '@surfline/web-common/dist/features/redux';
import configureStore from '../../redux/stores/perks';
import App from './perks';
import config from '../../config';
import { mount } from '../client';

const destination = document.getElementById('content');
const history = createHistory();
const store = configureStore(window.__data, history);
const {
  flags: {
    identity
  }
} = store.getState();

const mountApp = () => mount({
  store, history, destination, App, identity
});

setupFeatureFramework(
  config.splitio,
  identitySelector(store.getState()),
).then(mountApp).catch(mountApp);
